import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, forwardRef, HostBinding, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Professional, ProfessionalFilters } from 'src/app/commons/models/professional.model';
import { Project } from 'src/app/commons/models/project.model';
import * as ProfessionalActions from 'src/app/store/actions/professional.actions';
import { AppState } from 'src/app/store/reducers';


export const PAYMENT_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => ProfessionalFieldComponent),
};

@Component({
  selector: "app-professional-field",
  templateUrl: "./professional-field.component.html",
  styleUrls: ["./professional-field.component.scss"],
  providers: [PAYMENT_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class ProfessionalFieldComponent
  implements ControlValueAccessor, MatFormFieldControl<Professional> {
  private unsubscribe$ = new Subject<void>();
  private _value: Professional;
  private _disabled = false;

  private _required = false;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "professional-selection-field";
  autofilled?: boolean;
  professionalAriaDescribedBy?: string;

  @Input()
  professionalFilters: ProfessionalFilters = {};
  @Input()
  project: Project

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    @Optional() @Self() public ngControl: NgControl
  ) {
    this.actions$
      .pipe(
        ofType(ProfessionalActions.professionalSelected),
        takeUntil(this.unsubscribe$),
        map(({ professional }) => (professional ? new Professional(professional) : null))
      )
      .subscribe((professional) => (this.value = professional));

    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  stateChanges = new Subject<void>();
  id: string;

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {
    //TODO
  }
  onContainerClick(event: MouseEvent): void {
    if (!this.disabled) {
      if ((event.target as Element).tagName.toLowerCase() != "mat-icon") {
        this.selectProfessional();
      }
    }
  }

  ngOnChanges(): void {
    if (this.project) {
      this.professionalFilters = {
        ...this.professionalFilters,
        project_id: this.project.id
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  selectProfessional() {
    this.store$.dispatch(ProfessionalActions.selectProfessional({ filters: this.professionalFilters }));
  }

  clearProfessional() {
    this.value = null;
  }

  set value(value: Professional) {
    this._value = value;
    this.notifyValueChange();
    this.stateChanges.next();
  }

  get value(): Professional {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: Professional): void {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
